import React, { useEffect, useState } from 'react';

import PageSection from './PageSection';
import SmartLink from './SmartLink';
import * as styles from './Toast.module.css';

const Toast = ({ ctaUrl, ctaLabel }) => {
  const [showToast, setShowToast] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (typeof window === 'undefined') {
        return;
      }
      const html = document.documentElement;
      const body = document.body;
      const ratio = (html.scrollTop || body.scrollTop) / ((html.scrollHeight || body.scrollHeight) - html.clientHeight);
      if (ratio > 0.2 && !hasShown) {
        setShowToast(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showToast]); /*eslint-disable-line*/

  return (
    <PageSection className={showToast ? styles.toast : styles.hideToast}>
      <div className={styles.toastContainer}>
        <p>
          <SmartLink to={ctaUrl} isExternal="true" rel="noopener noreferrer">
            {ctaLabel}
          </SmartLink>{' '}
        </p>
        {/*eslint-disable-next-line*/}
        <div
          className={styles.close}
          onClick={() => {
            setShowToast(false);
            setHasShown(true);
          }}
        >
          X
        </div>
      </div>
    </PageSection>
  );
};

Toast.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default Toast;
